<div class="w-100">
    <div class="w-100 d-flex justify-content-between align-items-center px-1 gap-2 c-pointer">
        <div matRipple (click)="toggleMainNav()"
            class="flex-grow-1 flex-md-grow-0 px-3 py-2 rounded-2 zx-border-gray-v-light"
            [class.zx-border-green]="isDarkMode">
            <div class="d-flex align-items-center w-100" *ngIf="isLoading">
                <mat-spinner class="zx-small-icon-size"></mat-spinner>
            </div>
            <div class="d-flex align-items-center gap-2" *ngIf="!isLoading">
                <div class="flex-grow-1 d-flex align-items-center gap-2 overflow-hidden">
                    <div class="flex-shrink-0 d-flex align-items-center gap-2">
                        <img [src]="'assets/images/' + getPrintingService(0) + '-icon.svg'"
                            alt="choosen printing system icon" class="zx-small-icon-size">
                        <img *ngIf="branchName !== '' && printingService !== ''"
                            [src]="'assets/images/branches/' + branchName + '.png'" alt="choosen printing system icon"
                            class="zx-small-icon-size c-pointer">
                        <div class="d-flex align-items-center">
                            <span class="zx-text-small">
                                {{ 'choose-branch.naming.' + printingService + '.' + branchName | translate }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- <span class="spacer d-md-none"></span> -->
                <img *ngIf="!isDarkMode" src="/assets/images/tiny-arrow-icon.svg"
                    class="svg zx-tiny-icon-size c-pointer">
                <img *ngIf="isDarkMode" src="/assets/images/tiny-arrow-icon-green.svg"
                    class="svg zx-tiny-icon-size c-pointer">
            </div>
        </div>
        <div *ngIf="!isSU" (click)="toggleMainNav()" class="p-1 rounded-2 d-flex justify-content-center" mat-ripple
            [matTooltip]="'choose-branch.back-to-last-step' | translate" [matTooltipPosition]="'below'">
            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg" class="svg zx-small-icon-size">
            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg" class="svg zx-small-icon-size">
        </div>
        <span *ngIf="printingService === 'plotter'" class="spacer d-none d-md-flex"></span>
        <div *ngIf="printingService === 'plotter'" (click)="goToPrintingQueue()"
            class="p-1 rounded-2 d-flex justify-content-center" mat-ripple
            [matTooltip]="'order-complited.printed.view-que' | translate" [matTooltipPosition]="'below'">
            <img *ngIf="!isDarkMode" src="assets/images/queue-icon.svg" class="svg zx-small-icon-size">
            <img *ngIf="isDarkMode" src="assets/images/queue-icon-green.svg" class="svg zx-small-icon-size">
        </div>
        <span *ngIf="printingService === 'express'" class="spacer d-none d-md-flex"></span>
    </div>
    <div *ngIf="isNavOpen" class="position-relative d-flex w-100">
        <div class="d-flex position-absolute zx-top-2-px start-0 zx-z-index-2" [class.end-0]="isRTL">
            <div class="d-flex flex-column w-100 p-2 mx-1 rounded-2 bg-white d-flex shadow-85-strong"
                [class.zx-bg-dark]=" isDarkMode" [class.zx-border-gray-v-light]="!isDarkMode">

                <!-- OPTIONS -->
                <div *ngIf="isLoading" class="w-100 d-flex justify-content-center align-items-center"
                    style="height: 160px;">
                    <mat-spinner class="zx-small-icon-size"></mat-spinner>
                </div>

                <div class="w-100" *ngIf="!isLoading">
                    <div *ngFor="let service of myPrintingServicesList.slice(1); let i = index"
                        [class.d-none]="myPrintingServicesList.length <= 1"
                        [class.zx-border-gray-top-v-v-light]="i !== 0"
                        [class.zx-border-top-gray-25-pr]="i !== 0 && isDarkMode">
                        <div matRipple class="p-3 rounded-2 c-pointer"
                            (click)="chaingePrintingServiceAndBranch(service, realBranchesObjectsSelected[i+1].name)">
                            <div class="d-flex align-items-center gap-2 c-pointer">
                                <img [src]="'assets/images/' + getPrintingService(i+1) + '-icon.svg'"
                                    alt="choosen printing system icon" class="zx-small-icon-size c-pointer">
                                <img *ngIf="realBranchesObjectsSelected.length > 0"
                                    [src]="'assets/images/branches/' + realBranchesObjectsSelected[i+1].name + '.png'"
                                    alt="choosen printing system icon" class="zx-small-icon-size c-pointer">
                                <div class="d-flex align-items-center">
                                    <span class="zx-text-small c-pointer">
                                        {{ "choose-branch.naming." + service + '.' + myBranchesList[i+1] | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 10px;"></div>
                    <div matRipple
                        class="d-flex justify-content-center c-pointer px-3 py-2 rounded-2 w-100 rounded-pill zx-border-gray-v-v-light"
                        [class.zx-border-green]="isDarkMode" (click)="goHome()">
                        <div class="d-flex align-items-center justify-content-around c-pointer gap-2">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                                class="svg zx-small-icon-size c-pointer d-flex">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                                class="svg zx-small-icon-size c-pointer d-flex">
                            <span class="zx-text-tiny c-pointer" [class.text-green]="isDarkMode">
                                {{ "choose-branch.back-to-last-step" | translate }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- // OPTIONS -->

            </div>
        </div>
    </div>
    <div class="w-100 opacity-50 mt-3">
        <hr class="m-0">
    </div>
</div>